/**
 * @generated SignedSource<<46e78cf5a715de62e035bcd9da7a9202>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueFieldDataType = "SINGLE_SELECT" | "TEXT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type FieldsSectionFieldValues$data = {
  readonly id: string;
  readonly issueFieldValues: {
    readonly nodes: ReadonlyArray<{
      readonly field?: {
        readonly dataType?: IssueFieldDataType;
        readonly name?: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"FieldEditorsFieldSingleSelectValue" | "FieldEditorsFieldTextValue">;
    } | null | undefined> | null | undefined;
  };
  readonly " $fragmentType": "FieldsSectionFieldValues";
};
export type FieldsSectionFieldValues$key = {
  readonly " $data"?: FieldsSectionFieldValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldsSectionFieldValues">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldsSectionFieldValues",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 25
        }
      ],
      "concreteType": "IssueFieldValueConnection",
      "kind": "LinkedField",
      "name": "issueFieldValues",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FieldEditorsFieldTextValue"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FieldEditorsFieldSingleSelectValue"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "IssueFieldText",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "IssueFieldTextValue",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "IssueFieldSingleSelect",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "IssueFieldSingleSelectValue",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "issueFieldValues(first:25)"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "fe02e206378fb13479df16d67f81d0f9";

export default node;
